import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { Reason } from '../../../models/loyalty-reason.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyParamsService } from '../../../services/loyalty/params.service';
import { LoyaltyReasonService } from '../../../services/loyalty/reason.service';
import { Permission } from './../../../models/permission.model';
import { PermsService } from './../../../services/utils/perms.service';


@Component({
  selector: 'app-loyalty-reason',
  templateUrl: './loyalty-reason.component.html',
  styleUrls: ['./loyalty-reason.component.css']
})
export class LoyaltyReasonComponent implements OnInit {

  reasons: Array<Reason>;
  totalRecords: number;
  variable: boolean;
  serverPagination = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  newDataAvailable = false;
  paramsSign: Array<{value: string, label: string}>;
  paramsType: Array<{value: string, label: string}>;
  listStates: Array<{value: string, label: string}>;

  // Mostra tasti di edit, delete e recover
  reasonPermission: Permission;

  render = {
    datatable: false
  };

  constructor(
    private translate: TranslateService,
    public reasonService: LoyaltyReasonService,
    private router: Router,
    private paramService: LoyaltyParamsService,
    private srvPermission: PermsService
  ) { }

  ngOnInit() {
    this.variable = true;

    const TRANSLATIONS =   this.translate.get([
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended'
    ]);

    const PERMISSIONS = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'reason'});

    const REASON_SIGN = this.paramService.list(0, 200 , [{key: 'param_group', value: 'ReasonSign'}]);

    const REASON_TYPE = this.paramService.list(0, 200 , [{key: 'param_group', value: 'ReasonType'}]);

  Observable.zip(
    TRANSLATIONS,
    REASON_SIGN,
    REASON_TYPE,
    PERMISSIONS
  ).subscribe(([resTranslation, resSign, resType, resPermissions]) => {

    this.reasonPermission = resPermissions;

    this.listStates = [];
    this.listStates.push({ label: resTranslation[''], value: null });
    this.listStates.push({ label: resTranslation['common.status_notDeleted'], value: '0' });
    this.listStates.push({ label: resTranslation['common.status_onlyDeleted'], value: '1' });
    this.listStates.push({ label: resTranslation['common.status_onlySuspended'], value: '2' });

    this.paramsSign = [];
    this.paramsSign.push({value: null, label: ''});

    for (let param of resSign.data) {
    
      this.paramsSign.push({
        label: param.description,
        value: String(param.id)  // Converte ID in stringa
      });
    }
    
    this.paramsType = [];
    this.paramsType.push({ value: null, label: '' });
    
    for (let param of resType.data) {
      this.paramsType.push({
        label: param.description,
        value: String(param.id)  // Converte ID in stringa
      });
    }
    
    this.render.datatable = true;
  });

  }
  edit(reason: Reason) {
    this.router.navigate(['/loyalty/reason/form', reason.id]);
  }

  addNew() {
    this.router.navigate(['/loyalty/reason/form']);
  }

  remove(reason) {
    this.reasonService.remove(reason.id).subscribe(() => {
      this.newDataAvailable = true;
    });
  }

  recover(reason) {
    this.reasonService.recover(reason).subscribe((res) => {
      this.newDataAvailable = true;
    });
  }

  /*
  recover(reason){

    // faccio una copia dell'oggetto altrimenti se cambiassi direttamente il flg_state dell'oggetto vedrei la modifica sulla datatable prima dell'effettiva chiamata PUT per il recupero
    let reasonObj = Object.assign({}, reason)
    reasonObj.flg_state = '0';

    this.reasonService.update(reasonObj).subscribe(() => {
      this.newDataAvailable = true;
    });
  }
  */

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reason/loyalty-reason.component.ts